module.exports = __webpack_public_path__ + "img/result.6b0a34d0.png";